import script from "./MedTech.vue?vue&type=script&setup=true&lang=js"
export * from "./MedTech.vue?vue&type=script&setup=true&lang=js"

import "./MedTech.vue?vue&type=style&index=0&id=5643c636&scoped=true&lang=css"

import exportComponent from "/home/runcloud1user/webapps/kurdos-vue/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.26_vue@3.5.26_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5643c636"]])

export default __exports__